export type UAConf = {
  uri: string;
  password: string;
  authorization_user: string;
  display_name?: string;
  contact_uri?: string;
  guestToken?: string;
}

export type SetupUA = {
  sipWs: string;
  ua: UAConf;
}

export enum ReferResultType {
  REQUEST_SUCCESS,
  REQUEST_FAIL,
  TRYING,
  PROGRESS,
  ACCEPTED,
  FAILED
}
export interface ReferResult {
  type: ReferResultType
  message: string
}

export type CallMediaRequest = Partial<{requestedAudio: boolean, requestedVideo: boolean}>
